module.exports = __webpack_public_path__ + "img/gd-man-bottom-right.822e1ea4.png";